<template>
<span class="OTtableJobType">
    {{ row.get('job_type') }}
    <otif-icon icon="twitter-stream-list-black" title="Twitter Stream" v-if="row.get('job_type') === 'Twitter Stream'"/>
    <otif-icon icon="twitter-search-list-black" title="Twitter Search" v-if="row.get('job_type') === 'Twitter Search'"/>
    <otif-icon icon="web-list-black" title="Web" v-if="row.get('job_type') === 'Web'"/>
    <otif-icon icon="ecm-list-black" title="ECM" v-if="row.get('job_type') === 'ECM'"/>
    <otif-icon icon="rdbms-list-black" title="RDBMS" v-if="row.get('job_type') === 'RDBMS'"/>
    <otif-icon icon="local-list-black" title="Local Documents" v-if="row.get('job_type') === 'Local Documents'"/>
</span>
</template>

<script>

export default {
    props: ['row', 'colnumber', 'column', 'rownumber', 'columns', 'rows']
}

</script>
